/*
 * Ivatherm B1 — INCI list truncation
 * Collapses the long INCI chemical list inside the "Ingrediente Active"
 * accordion behind a "Citește mai mult" toggle. The active-ingredient bullets
 * and the formulation disclaimer stay fully visible.
 *
 * The INCI lives as its own <p><strong>INCI:</strong> … </p> inside a
 * rich-text metafield blob, so it's targeted precisely (the theme's native
 * text-truncator can only wrap whole Liquid-rendered content, not a sub-node).
 *
 * Trigger: rendered LINE count (not word/char). The toggle only appears when
 * the clamped INCI actually overflows MAX_LINES — short lists show in full.
 * Update-safe: iva- prefixed; logged in CUSTOMIZATIONS.md.
 */
(function () {
  'use strict';

  var MAX_LINES = 2;

  function setup(p) {
    if (p.dataset.ivaInci) return;
    p.dataset.ivaInci = '1';
    p.classList.add('iva-inci', 'iva-inci--clamped');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'iva-inci__toggle';
    btn.textContent = 'Citește mai mult';
    btn.hidden = true;
    p.insertAdjacentElement('afterend', btn);

    var expanded = false;
    btn.addEventListener('click', function () {
      expanded = !expanded;
      p.classList.toggle('iva-inci--clamped', !expanded);
      btn.textContent = expanded ? 'Citește mai puțin' : 'Citește mai mult';
    });

    // Show the toggle only when the clamped INCI overflows. Measured lazily via
    // ResizeObserver so it works even though the accordion starts collapsed
    // (the <p> has no layout until the panel opens) and re-checks on resize.
    function check() {
      if (expanded) return;
      btn.hidden = p.scrollHeight <= p.clientHeight + 1;
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(check).observe(p);
    } else {
      window.addEventListener('resize', check);
      check();
    }
  }

  function init() {
    var nodes = document.querySelectorAll(
      '.product__accordion .metafield-rich_text_field p, .product__block .metafield-rich_text_field p'
    );
    nodes.forEach(function (p) {
      var strong = p.querySelector('strong');
      if (strong && /^\s*INCI\b/i.test(strong.textContent)) setup(p);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
